export function deleteUndefinedValueProps<O>(obj: O): O {
  const result = {};

  Object.keys(obj).forEach(key => {
    if (typeof obj[key] !== 'undefined') {
      result[key] = obj[key];
    }
  });

  return result as O;
}

export function uid() {
  return Date.now().toString(36) + Math.random().toString(36).substring(2);
}

export function judgingTheSignOfNumber(num: string | number): -1 | 0 | 1 {
  num = Number(String(num).replace(/([+-]?\d+(\.\d+)?).?/, '$1'));

  if (Number.isNaN(num)) {
    return 0;
  }

  return num > 0 ? 1 : num < 0 ? -1 : 0;
}

export function measureText({
  fontFamily,
  fontSize,
  text
}: {
  fontFamily: string;
  fontSize: number | string;
  text: string;
}) {
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  ctx.font = `${fontSize}px ${fontFamily}`;

  return ctx.measureText(text);
}

// eslint-disable-next-line complexity, sonarjs/cognitive-complexity
export function defaultsDeep<
  T extends { [k: string]: any } | any[],
  S extends { [k: string]: any } | any[]
>(target: T, source: S, { overlay = false, depth = 0, currentDepth = 0 } = {}): T & S {
  const keysArr = Array.isArray(source)
    ? Array.from(Array(source.length), (_, i) => i)
    : Object.keys(source);

  for (let i = 0; i < keysArr.length; i += 1) {
    const key = keysArr[i];

    if (overlay ? source[key] != null : (target as T & S)[key] == null) {
      if (
        currentDepth < depth &&
        (Array.isArray(source[key]) || (typeof source[key] === 'object' && source[key] !== null))
      ) {
        target[key] = defaultsDeep(
          (target[key] || (Array.isArray(source[key]) ? [] : {})) as T,
          source[key] as S,
          { overlay, depth, currentDepth: currentDepth + 1 }
        );
      } else {
        target[key] = source[key] as T & S;
      }
    }
  }

  return target as T & S;
}
